import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetClose, SheetTitle } from "@/components/ui/sheet";
import { CEmblem } from "@/components/Brand";

const NAV = [
  { to: "/a-propos", label: "À propos", id: "a-propos" },
  { to: "/contribuer", label: "Contribuer", id: "contribuer" },
  { to: "/contact", label: "Contact", id: "contact" },
];

export const Logo = ({ light = false }) => (
  <Link
    to="/"
    data-testid="logo-link"
    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    className="group inline-flex items-center gap-2 leading-none min-w-0"
  >
    <CEmblem className="h-7 w-7 sm:h-8 sm:w-8 shrink-0" primary={light ? "#F7F5F0" : "#111111"} />
    <span className="flex flex-col min-w-0">
      <span
        className={`font-logo font-black tracking-tight text-[0.98rem] sm:text-[1.35rem] md:text-[1.55rem] leading-[0.9] whitespace-nowrap ${
          light ? "text-paper" : "text-ink"
        }`}
      >
        CONTRE-ÉPREUVE
      </span>
      <span
        className={`hidden sm:block text-[0.6rem] md:text-[0.66rem] font-medium tracking-wide mt-1 ${
          light ? "text-paper/70" : "text-muted-ink"
        }`}
      >
        Faits, sources et zones de doute.
      </span>
    </span>
  </Link>
);

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50">
      <div className="bg-paper border-b border-ink">
        <div className="mx-auto max-w-7xl px-5 md:px-8 h-[70px] flex items-center justify-between gap-3 md:gap-6">
          <Logo />

          <nav className="hidden lg:flex items-center gap-7">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.id}-link`}
                className={({ isActive }) =>
                  `text-sm font-semibold uppercase tracking-wide transition-colors duration-200 ${
                    isActive ? "text-orange" : "text-ink hover:text-orange"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2 sm:gap-3">
            <Link
              to="/contribuer"
              data-testid="header-propose-btn"
              className="hidden sm:inline-flex items-center bg-orange text-ink font-bold text-sm uppercase tracking-wide px-5 h-10 rounded-[10px] hover:bg-ink hover:text-orange transition-colors duration-200"
            >
              Proposer un article
            </Link>

            <div className="lg:hidden">
              <Sheet open={open} onOpenChange={setOpen}>
                <SheetTrigger asChild>
                  <button data-testid="mobile-menu-btn" aria-label="Menu" className="h-10 w-10 flex items-center justify-center border border-ink text-ink">
                    <Menu size={20} strokeWidth={2} />
                  </button>
                </SheetTrigger>
                <SheetContent side="right" aria-describedby={undefined} className="bg-paper w-72 border-l border-ink">
                  <SheetTitle className="sr-only">Menu de navigation</SheetTitle>
                  <nav className="mt-10 flex flex-col gap-1">
                    {NAV.map((n) => (
                      <SheetClose asChild key={n.to}>
                        <Link
                          to={n.to}
                          data-testid={`mobile-nav-${n.id}-link`}
                          className="font-display font-bold text-2xl uppercase text-ink hover:text-orange transition-colors duration-200 py-2 border-b border-line"
                        >
                          {n.label}
                        </Link>
                      </SheetClose>
                    ))}
                    <SheetClose asChild>
                      <Link
                        to="/contribuer"
                        data-testid="mobile-propose-btn"
                        className="mt-5 inline-flex items-center justify-center bg-orange text-ink font-bold text-sm uppercase tracking-wide px-5 h-11 rounded-[10px] hover:bg-ink hover:text-orange transition-colors duration-200"
                      >
                        Proposer un article
                      </Link>
                    </SheetClose>
                  </nav>
                </SheetContent>
              </Sheet>
            </div>
          </div>
        </div>
      </div>
      <div className="h-1 bg-orange" />
    </header>
  );
};
